// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Marketplace
 */
export interface Marketplace {
  /**
   * Marketplace identifier
   * @type {string}
   * @memberof Marketplace
   */
  id: string;
  /**
   * Marketplace type (e.g., awsmarketplace, azuremarketplace, gcpmarketplace)
   * @type {string}
   * @memberof Marketplace
   */
  type: string;
  /**
   * Whether the marketplace link is legacy
   * @type {boolean}
   * @memberof Marketplace
   */
  legacy: boolean;
  /**
   * Marketplace entitlement identifier
   * @type {string}
   * @memberof Marketplace
   */
  entitlementID?: string | null;
  /**
   * External marketplace account identifier
   * @type {string}
   * @memberof Marketplace
   */
  externalAccountID?: string | null;
  /**
   * External marketplace reporting identifier
   * @type {string}
   * @memberof Marketplace
   */
  externalReportingID?: string | null;
  /**
   * Whether the marketplace link is currently active
   * @type {boolean}
   * @memberof Marketplace
   */
  isActive: boolean;
  /**
   * Reason the marketplace link is inactive (if applicable)
   * @type {string}
   * @memberof Marketplace
   */
  inactiveReason?: string | null;
  /**
   * When the marketplace was deleted (if applicable)
   * @type {Date}
   * @memberof Marketplace
   */
  deletedAt?: Date | null;
}

/**
 * Check if a given object implements the Marketplace interface.
 */
export function instanceOfMarketplace(value: object): value is Marketplace {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  if (!('legacy' in value) || value['legacy'] === undefined) return false;
  if (!('isActive' in value) || value['isActive'] === undefined) return false;
  return true;
}

export function MarketplaceFromJSON(json: any): Marketplace {
  return MarketplaceFromJSONTyped(json, false);
}

export function MarketplaceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Marketplace {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    type: json['type'],
    legacy: json['legacy'],
    entitlementID:
      json['entitlementID'] == null ? undefined : json['entitlementID'],
    externalAccountID:
      json['externalAccountID'] == null ? undefined : json['externalAccountID'],
    externalReportingID:
      json['externalReportingID'] == null
        ? undefined
        : json['externalReportingID'],
    isActive: json['isActive'],
    inactiveReason:
      json['inactiveReason'] == null ? undefined : json['inactiveReason'],
    deletedAt:
      json['deletedAt'] == null ? undefined : new Date(json['deletedAt']),
  };
}

export function MarketplaceToJSON(json: any): Marketplace {
  return MarketplaceToJSONTyped(json, false);
}

export function MarketplaceToJSONTyped(
  value?: Marketplace | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    type: value['type'],
    legacy: value['legacy'],
    entitlementID: value['entitlementID'],
    externalAccountID: value['externalAccountID'],
    externalReportingID: value['externalReportingID'],
    isActive: value['isActive'],
    inactiveReason: value['inactiveReason'],
    deletedAt:
      value['deletedAt'] === null
        ? null
        : (value['deletedAt'] as any)?.toISOString(),
  };
}
